import { useState } from 'react'

function applyNightMode(on: boolean) {
  document.documentElement.classList.toggle('dark', on)
  localStorage.setItem('nightMode', String(on))
}

export function useNightMode() {
  const [nightMode, setNightMode] = useState(() => {
    const saved = localStorage.getItem('nightMode') === 'true'
    applyNightMode(saved)
    return saved
  })

  const toggleNightMode = () => {
    const next = !nightMode
    applyNightMode(next)
    setNightMode(next)
  }

  return { nightMode, toggleNightMode }
}
